module.exports = __webpack_public_path__ + "media/images/athletes/268-a58afd4a2c4881dbdb9b06f1c92eb0c2.png";